import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, "Your Profile", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("First name")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Last name")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Email")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Roles")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "q-mt-xl" }, "Your last performed operations", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_audit_log_operator_activities = _resolveComponent("audit-log-operator-activities")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_q_list, {
      class: "q-mb-lg",
      bordered: "",
      padding: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.profile?.firstName), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.profile?.lastName), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.profile?.email), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.profile?.roles.map(role => role.name).join(', ')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_7,
    _createVNode(_component_audit_log_operator_activities, { activities: _ctx.activities }, null, 8, ["activities"])
  ]))
}